/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * SVM API
 * SVM API documentation
 * OpenAPI spec version: 1.0
 */

export type GetUsersRolesItem = (typeof GetUsersRolesItem)[keyof typeof GetUsersRolesItem];

export const GetUsersRolesItem = {
    Admin: 'Admin',
    Pilot: 'Pilot'
} as const;
